var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-choice-set-stu-class-merge"})
}
var staticRenderFns = []

export { render, staticRenderFns }